/**
 * axios封装
 * 请求拦截、响应拦截、错误统一处理
 */
import axios from 'axios';
import store from '@/store/index';
import { Message } from 'element-ui'
import {router} from './router'

/**
 * 跳转登录页
 * 携带当前页面路由，以期在登录页面完成登录后返回当前页面
 */
const toLogin = () => {
    art.toLogin();
    /*router.replace({
        path: '/login',
        query: {
            redirect: router.currentRoute.fullPath
        }
    });*/
}

/**
 * 请求失败后的错误统一处理
 * @param {Number} status 请求失败的状态码
 */
const errorHandle = (status, other) => {
    // 状态码判断
    switch (status) {
        // 401: 未登录状态，跳转登录页
        case 401:
            break;
            // 406 token过期
            // 清除token并跳转登录页
        case 901:
            console.log('901');
            break;
            // 406 token过期
            // 清除token并跳转登录页
        case 902:
            
            break;
        case 406:
            //Message.error('登录过期，请重新登录');
            //store.dispatch('tokenStatus/updateToken', null);
            /*setTimeout(() => {
                toLogin();
            }, 1000);
            */
            break;
            // 404请求不存在
        case 404:
            Message.error('请求的资源不存在');
            break;
        default:
            Message.error(other);
    }
}

// 创建axios实例
var instance = axios.create({
    timeout: 1000 * 12,
    headers: {
        'content-type': 'application/x-www-form-urlencoded;charset=UTF-8',
    },
    errorNotTips: false,
});
// 设置post请求头
//instance.defaults.headers.post['Accept'] = 'application/json; charset=UTF-8';
//instance.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded; charset=UTF-8';
//instance.defaults.headers.post['Content-Type'] = 'application/json; charset=UTF-8';

/**
 * 请求拦截器
 * 每次请求前，如果存在token则在请求头中携带token
 */
instance.interceptors.request.use(
    config => {
        // 登录流程控制中，根据本地是否存在token判断用户的登录情况
        // 但是即使token存在，也有可能token是过期的，所以在每次的请求头中携带token
        // 后台根据携带的token判断用户的登录情况，并返回给我们对应的状态码
        // 而后我们可以在响应拦截器中，根据状态码进行一些统一的操作。
        const token = store.state.tokenStatus.token;
        token && (config.headers.Authorization = token);
        return config;
    },
    error => Promise.error(error)
)

// 响应拦截器
instance.interceptors.response.use(
    // 请求成功
    res => {
        var tokenInvalidNotSkiptoLogin = res.config.headers.tokenInvalidNotSkiptoLogin; //token失效不跳转登录页
        var errorNotTips = res.config.headers.errorNotTips;
        if (res.data.success) {
            return Promise.resolve(res.data)
        }
        else {
            console.log(errorNotTips,'errorNotTips')
            if(!errorNotTips){errorHandle(res.status, res.data.msg)};
            if (res.data.code == '902') {
                // store.commit('signOut');
                if(!tokenInvalidNotSkiptoLogin){
                    var url = window.location.href;
                    setTimeout(() => {
                        sessionStorage.setItem("visitUri", url);
                        router.replace({
                            path:'/callback.html',
                            query:{
                                isRefreshToken:1
                            }
                        })
                    }, 1000)
                }
                return Promise.reject(res.data)
            }
            else {
                return Promise.reject(res.data)
            }
        }
    },
    // 请求失败
    error => {
        const {
            response
        } = error;
        if (res) {
            var errorNotTips = res.config.headers.errorNotTips;
            if(!errorNotTips) errorHandle(res.status, res.data.msg);
            return Promise.reject(res);
        } else {
            // 处理断网的情况
            // eg:请求超时或断网时，更新state的network状态
            // network状态在app.vue中控制着一个全局的断网提示组件的显示隐藏
            // 关于断网组件中的刷新重新获取数据，会在断网组件中说明
        }
    }
);

export default instance;